import _regeneratorRuntime from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _classCallCheck from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _callSuper from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/callSuper.js";
import _inherits from "G:/webgit/pc-chitengmall/node_modules/@babel/runtime/helpers/esm/inherits.js";
import "core-js/modules/es.array.push.js";
import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import Price from '@/components/price/index.vue';
import Header from '@/common/header.vue';
import Footer from '@/common/footer.vue';
import NavMenu from '@/common/navmenu.vue';
import DropDown from '@/common/dropdown.vue';
import { readCookie } from '@/tools/tools';
import { invoiceList, deleteInvoice as _deleteInvoice, pageVisit as _pageVisit } from '@/services/http';
var default_1 = /*#__PURE__*/function (_Vue) {
  function default_1() {
    var _this;
    _classCallCheck(this, default_1);
    _this = _callSuper(this, default_1, arguments);
    _this.invoiceList = [];
    // 有无数据
    _this.isNodata = false;
    return _this;
  }
  _inherits(default_1, _Vue);
  return _createClass(default_1, [{
    key: "created",
    value: function created() {
      this.getInvoiceList();
      this.pageVisit();
    }
    //  获取收货地址列表
  }, {
    key: "getInvoiceList",
    value: function () {
      var _getInvoiceList = _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var res;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return invoiceList({
                pageNo: 1,
                pageSize: 40,
                companyId: 1
              });
            case 2:
              res = _context.sent;
              this.invoiceList = res.data.data;
              this.isNodata = res.data.data.length === 0;
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this);
      }));
      function getInvoiceList() {
        return _getInvoiceList.apply(this, arguments);
      }
      return getInvoiceList;
    }() // 编辑收货地址
  }, {
    key: "editInvoice",
    value: function editInvoice(id) {
      this.$router.push("/invoiceedit?id=".concat(id));
    }
  }, {
    key: "deleteInvoice",
    value: function deleteInvoice(id) {
      var _this2 = this;
      var $this = this;
      this.$confirm('确定删除该发票？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/_asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return _deleteInvoice({
                id: id
              });
            case 2:
              res = _context2.sent;
              if (res.data.code === 100) {
                $this.getInvoiceList();
                _this2.$message.success('删除成功!');
              } else {
                _this2.$message.error(res.data.message);
              }
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }))).catch(function () {});
    }
    // 访问页面数据埋点
  }, {
    key: "pageVisit",
    value: function pageVisit() {
      var anchor = readCookie('anchor');
      _pageVisit({
        pageType: 14,
        equip: anchor ? anchor.equip : 4,
        version: anchor ? anchor.version : '',
        src: anchor ? anchor.src ? anchor.src : 2 : 4,
        model: anchor ? anchor.model : '',
        equipVersion: anchor ? anchor.equipVersion : '',
        equipMeid: anchor ? anchor.equipMeid : '',
        companyId: 1
      });
    }
  }]);
}(Vue);
default_1 = __decorate([Component({
  components: {
    Header: Header,
    Price: Price,
    Footer: Footer,
    DropDown: DropDown,
    NavMenu: NavMenu
  }
})], default_1);
export default default_1;